import { CardContent } from "@mui/material";

import commoncss from "../../myfin_v2/css/common.module.css";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusBlack.svg";
const AddFooters = ({
  checkBoxList = [],
  selectedItems = [],
  setSelectedItems,
  setShowAddEditSignatoryModal,
}) => {
   const footerAllowedLabels = ["BS", "PL", "cashflow", "socie", "disclosure"];

  const filteredCheckBoxList = checkBoxList.filter((item) =>
    footerAllowedLabels.includes(item.value)
  );

  const handleCheckboxChange = (value) => {
    setSelectedItems((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };

  const handleSelectAll = (checked) => {
    setSelectedItems(
      checked ? filteredCheckBoxList.map((i) => i.value) : []
    );
  };

  const isAllSelected =
    // checkBoxList.length > 0 &&
    // selectedItems.length === checkBoxList.length;
    filteredCheckBoxList.length > 0 &&
    filteredCheckBoxList.every((item) => selectedItems.includes(item.value));

  return (
    <CardContent>
      {/* HEADER */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 15px",
          //gap:"20px",
         // margin: "17px 0",
        }}
      >
        <span className={commoncss.label3}>Add Signatory To</span>

      <div className={`${commoncss.clickable} ml-3 my-2`}  style={{ border: "1px solid #A0DABC", borderRadius: "8px" , padding: "8px 10px"}} onClick={() => { setShowAddEditSignatoryModal(true) }}>
        <PlusIcon height={18} width={18} style={{ marginTop: "-3px"}} /> &nbsp;<span className={`${commoncss.textLabel} ${commoncss.fs15}`}>Add Signatory</span>
      </div> 
       </div>
       
       <div
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0 8px",
          gap: "50px",
          flexWrap: "wrap",
        }}
       >
        <label className="d-flex align-items-center gap-1 cursor-pointer" style={{ gap: "4px"}}>
          <input
            type="checkbox"
            checked={isAllSelected}
            onChange={(e) => handleSelectAll(e.target.checked)}
            className={commoncss.commonCustomCheckbox}
          />
          <span className={`${commoncss.label6} ${commoncss.headingColor} ${commoncss.vaSuper} ${commoncss.fs14}`}>
            All Pages
          </span>
        </label>
     
        
      {/* </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "12px",
          padding: "12px",
        }}
      > */}
        {filteredCheckBoxList.map(({ label, value }) => (
          <label
            key={value}
            className="d-flex align-items-center gap-1 cursor-pointer"
            style={{ gap: "4px"}}
          >
            <input
              type="checkbox"
              checked={selectedItems.includes(value)}
              onChange={() => handleCheckboxChange(value)}
              className={commoncss.commonCustomCheckbox}
            />
            <span
              className={`${commoncss.label6} ${commoncss.headingColor} ${commoncss.vaSuper} ${commoncss.fs14}`}
            >
              {label}
            </span>
          </label>
        ))}
      </div>
    </CardContent>
  );
};

export default AddFooters;
